{
  "title": "Toll the Dead",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Necromancy cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You point at one creature you can see within range, and the sound of a dolorous bell fills the air around it for a moment. The target must succeed on a Wisdom saving throw or take 1d8 necrotic damage. If the target is missing any of its hit points, it instead takes 1d12 necrotic damage.",
    "At Higher Levels. The spell’s damage increases by one die when you reach 5th level (2d8 or 2d12), 11th level (3d8 or 3d12), and 17th level (4d8 or 4d12)."
  ],
  "spellLists": ["cleric", "eldritch-knight", "arcane-trickster", "warlock", "wizard"]
}
